<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="frontsales_1"></a><p class="fm1">Praise for Conversations with the Fat Girl</p><p class="fsq">“Filled with deliciousness, but its calories are far from empty. Liza Palmer has created, to borrow her own heroine Maggie’s phrase, a pink pastry box o’magic.”</p><p class="fsqs">—Gayle Brandeis, author of Fr<em>uitflesh: Seeds of Inspiration for Women Who Write</em> and <em>The Book of Dead Birds: A Novel</em></p><p class="fsq">“In this touching story from Liza Palmer, Maggie learns to let go, move on, and—finally—trust herself. This is a from-the-heart debut you won’t soon forget!”</p><p class="fsqs">—Megan Crane, author of <em>English as a Second Language</em> and <em>Everyone Else’s Girl</em></p><p class="fsq">“This is the story about two best friends, boundary issues, and the unraveling of a shared history. Liza Palmer puts her finger delicately, yet forcefully, on the crucial moment in every failing freindship, the one where we must choose either to untangle and extricate ourselves or become erased by our own compliance.</p><p class="fsqs">—Amanda Stern, author of <em>The Long Haul</em></p><p class="fsq">“<em>Conversations with the Fat Girl</em> is a wry, dry, and ultimately winning novel featuring a saucy heroine to whom all girls (fat and thin) will relate: Maggie starts out looking for excuses, but ends up finding herself.”</p><p class="fsqs">—Wendy Shanker, <em>The Fat Girls’ Guide to Life</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Conversationsw_fron_1.vue?7f96a5df